function SingleUserPage() {
  return <div>single user</div>;
}

export default SingleUserPage;
